import { Dialog } from 'quasar'
import MessagePluginDialog from 'components/partials/dialogs/MessagePluginDialog'
import UnsubscribedPluginDialog from 'components/partials/dialogs/UnsubscribedPluginDialog.vue'

const MessageDialog = (params = {}) => {
  return Dialog.create({
    component: MessagePluginDialog,
    componentProps: params
  })
}

export const UnsubscribedDialog = (params = {}) => {
  return Dialog.create({
    component: UnsubscribedPluginDialog,
    componentProps: params
  })
}

export default MessageDialog
